import { render, staticRenderFns } from "./integral-list.vue?vue&type=template&id=2c32fd9a&scoped=true"
import script from "./integral-list.vue?vue&type=script&lang=js"
export * from "./integral-list.vue?vue&type=script&lang=js"
import style0 from "./integral-list.vue?vue&type=style&index=0&id=2c32fd9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32fd9a",
  null
  
)

export default component.exports